
































































import Vue from "vue";

import IconCardPronunciation from "@joyz/app-core/assets/icons/transparent/DrillPronunciation.svg";
import IconCorrect from "@joyz/app-core/assets/icons/Correct.svg";
import IconIncorrect from "@joyz/app-core/assets/icons/Incorrect.svg";
import IconSpeaker from "@joyz/app-core/assets/icons/default/Speaker.svg";
import IconSkipped from "@joyz/app-core/assets/icons/misc/DrillSkip.svg";
import IconUserVoice from "@joyz/app-core/assets/icons/default/UserVoice.svg";

import {
  DrillQuestionAndAnswers,
  DrillUserAnswer,
  ApiDrillPronunciation,
  DrillPronunciationAnswer,
  DrillLearningStatus
} from "@tt-app/models/exercise";
import { IpaEvaluated, IpaEvaluation } from "@joyz/app-core/models/typography";

interface Data {
  icons: { [key: string]: string };
}

interface Methods {
  getCorrectnessIcon: (answer: DrillUserAnswer) => string;
  getLearnStatus: (learnStatus: DrillLearningStatus) => number;
  getPronunciationIpa: (answer: DrillPronunciationAnswer) => IpaEvaluation;
  playUserAudio: (answer: DrillPronunciationAnswer) => void;
  playWordAudio: (exercise: DrillQuestionAndAnswers) => void;
}

interface Computed {
  allAnswers: DrillUserAnswer[];
}

interface Props {
  exercise: DrillQuestionAndAnswers;
  questionIndex: number;
  summary: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "DrillAnswerPronunciation",

  props: {
    exercise: { type: Object as () => DrillQuestionAndAnswers, required: true },
    questionIndex: { type: Number, required: true },
    summary: { type: Boolean, default: false }
  },

  data() {
    return {
      icons: {
        drillType: IconCardPronunciation,
        skipped: IconSkipped,
        speaker: IconSpeaker,
        userVoice: IconUserVoice
      }
    };
  },

  computed: {
    allAnswers() {
      if (!this.summary) {
        return this.exercise.allAnswers;
      }

      return this.exercise.allAnswers.length ? this.exercise.allAnswers.slice(0, 1) : [];
    }
  },

  methods: {
    getCorrectnessIcon(answer) {
      return answer.correction.isCorrect ? IconCorrect : IconIncorrect;
    },

    getLearnStatus(learnStatus) {
      return learnStatus !== null ? learnStatus : -1;
    },

    getPronunciationIpa(answer) {
      return answer.evaluation.map((e): IpaEvaluated => ({ text: e.ipa, isCorrect: e.isCorrect }));
    },

    playUserAudio(answer) {
      if (answer.audioBlob) {
        const audioUrl = URL.createObjectURL(answer.audioBlob);

        this.$emit("play-user-audio", { audioUrl });
      }
    },

    playWordAudio(exercise) {
      const word = (exercise.question as ApiDrillPronunciation).word;
      const audioUrl = word ? word.audio : undefined;

      if (audioUrl) {
        this.$emit("play-example-audio", { audioUrl });
      }
    }
  }
});
